export default __webpack_public_path__ + "static/media/onboarding-graphics-aspiring-founder.4be093e2.png";